export enum EModules {
  DASHBOARD = 'dashboard',
  CALENDAR = 'calendar',
  LEAVE_DAYS = 'leave_days',
  HOLIDAY = 'holiday',
  USERS = 'users',
  OFFICE_ORDERLY = 'office_orderly',
  ATTENDANCE = 'attendance',
  DEPARTMENTS = 'departments',
  TEAM_CONTRIBUTIONS = 'team_contributions',
  EXPENSES = 'expenses',
  NOTIFICATION = 'notification',
  PROJECTS = 'projects',
  REFUND = 'refund',
}
